import React from "react";

const VAT_RATE = 0.2;

const coupons = {
  // '7dollarsofffirstmonth': {
  //   discount: 700,
  //   type: 'amount_off',
  //   salesText: {
  //     'title': 'Get everything Wordtracker has to offer for a month for $10',
  //     'priceMark': <span className='price-mark price-mark-smaller'><span className='dollar-sign'>$</span>10<span className='only'>only</span></span>,
  //     'buttonBilling': 'Start my $10 trial',
  //     'buttonDetailsHint': <>Get Wordtracker for just <strong>$10 for a month</strong>, and only <strong>$17/month</strong> after that, forever.</>,
  //     'buttonHint': <>By signing up, you agree to our <a href='/terms' target='_blank'>terms</a>.<br/> After your first month trial, your regular price will be <strong>$17/month</strong>. You can cancel any time.</>,
  //   }
  // }
};

const plans = JSON.parse(`{"bronze_trial_plan":{"id":"price_1PpPoZ2NavrKZ6s0dxm76DqX","lookup_key":"bronze_trial_plan","plan_code":"price_1PpPoZ2NavrKZ6s0dxm76DqX","is_trial_plan":true,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"bronze_monthly":{"id":"price_1Q5kNm2NavrKZ6s0od4LkYr1","lookup_key":"bronze_monthly","plan_code":"price_1Q5kNm2NavrKZ6s0od4LkYr1","is_trial_plan":false,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"monthly","interval_count":1,"unit_amount_in_cents":2400},"bronze_annual":{"id":"lannister_bronze_annual","lookup_key":"bronze_annual","plan_code":"lannister_bronze_annual","is_trial_plan":false,"name":"Wordtracker Bronze Subscription","tier":"bronze","period":"annual","interval_count":1,"unit_amount_in_cents":19500},"silver_trial_plan":{"id":"price_1PpPpI2NavrKZ6s08EHmUNHx","lookup_key":"silver_trial_plan","plan_code":"price_1PpPpI2NavrKZ6s08EHmUNHx","is_trial_plan":true,"name":"Wordtracker Silver Subscription","tier":"silver","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"silver_monthly":{"id":"lannister_silver_monthly","lookup_key":"silver_monthly","plan_code":"lannister_silver_monthly","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"monthly","interval_count":1,"unit_amount_in_cents":6900},"silver_annual":{"id":"lannister_silver_annual","lookup_key":"silver_annual","plan_code":"lannister_silver_annual","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"annual","interval_count":1,"unit_amount_in_cents":44900},"gold_trial_plan":{"id":"price_1PpPrj2NavrKZ6s0hVgx1eFi","lookup_key":"gold_trial_plan","plan_code":"price_1PpPrj2NavrKZ6s0hVgx1eFi","is_trial_plan":true,"name":"Wordtracker Gold Subscription","tier":"gold","period":"monthly","interval_count":1,"unit_amount_in_cents":1000},"gold_monthly":{"id":"lannister_gold_monthly","lookup_key":"gold_monthly","plan_code":"lannister_gold_monthly","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"monthly","interval_count":1,"unit_amount_in_cents":9900},"gold_annual":{"id":"lannister_gold_annual","lookup_key":"gold_annual","plan_code":"lannister_gold_annual","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"annual","interval_count":1,"unit_amount_in_cents":64000},"silver_annual_for_price_of_bronze":{"id":"price_1QXmxV2NavrKZ6s0m983e1AS","lookup_key":"silver_annual_for_price_of_bronze","plan_code":"price_1QXmxV2NavrKZ6s0m983e1AS","is_trial_plan":false,"name":"Wordtracker Silver Subscription","tier":"silver","period":"annual","interval_count":1,"unit_amount_in_cents":24000},"gold_annual_for_price_of_silver":{"id":"price_1QXmww2NavrKZ6s0zbBX32Uc","lookup_key":"gold_annual_for_price_of_silver","plan_code":"price_1QXmww2NavrKZ6s0zbBX32Uc","is_trial_plan":false,"name":"Wordtracker Gold Subscription","tier":"gold","period":"annual","interval_count":1,"unit_amount_in_cents":44900}}`);
const planLimits = JSON.parse(`{"bronze":{"results":1000,"domain_results":1000,"competitors":10,"ranking_lists":1,"ranking_keywords":200,"countries":-1,"searches_per_day":500,"segmentation":true,"api":false,"scout":false,"metrics":true,"trial":{"ranking_lists":1}},"gold":{"results":2000,"domain_results":2000,"competitors":50,"ranking_lists":10,"ranking_keywords":200,"countries":-1,"searches_per_day":-1,"segmentation":true,"api":99,"scout":true,"metrics":true,"trial":{"ranking_lists":1}},"hold":{"results":50,"domain_results":50,"competitors":5,"ranking_lists":1,"ranking_keywords":200,"countries":-1,"searches_per_day":500,"segmentation":true,"api":false,"scout":false,"metrics":true,"trial":{"ranking_lists":1},"disabled_features":["lists","ranking","unlimited_searches","bulk_search"]},"silver":{"results":1000,"domain_results":1000,"competitors":20,"ranking_lists":5,"ranking_keywords":200,"countries":-1,"searches_per_day":1000,"segmentation":true,"api":false,"scout":true,"metrics":true,"trial":{"ranking_lists":1}}}`);

export const getNextPlanForLimits = (user, limit, requested) => {
  const userTier = getUserTier(user);
  const userPeriod = getUserPeriod(user);

  const nextTier = Object.values(tiers).find(tier => {
    return requested <= tier.limits[limit];
  });

  if (nextTier && nextTier.name !== userTier) {
    return `${nextTier.name}_${userPeriod}`;
  }

  return null;
}

export const getMonthlyForTier = tier => {
  return Object.values(plans).find(plan => plan.tier === tier && plan.period === 'monthly' && !plan.is_trial_plan);
}

export const getAnnualForTier = tier => {
  return Object.values(plans).find(plan => plan.tier === tier && plan.period === 'annual' && !plan.is_trial_plan);
}

export const getUserTier = user => {
  if (user.isFreeUser) return 'free';
  return user.subscription.tier;
}

const getUserPeriod = user => {
  if (user.isFreeUser) return null;
  return user.subscription.period;
}

let tiers = [ "bronze", "silver", "gold" ];

tiers = tiers.reduce((obj, tierName) => {
  const limits = planLimits[tierName];
  const { results, domain_results, competitors, ranking_lists, ranking_keywords, countries, searches_per_day } = limits;
  const tier = { name: tierName };
  tier.limits = { results, domain_results, competitors, ranking_lists, ranking_keywords, countries, searches_per_day }
  obj[tierName] = tier;
  return obj;
}, {});

const sales = {
  generic_plan: {
    states: {
      default: {
        title: 'Subscribe to Wordtracker',
        buttonDetails: 'Continue...',
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we log you in...
        </p>
      },
      expired_with_valid_card: {
        title: 'Your subscription has ended. Subscribe to reactivate your account',
        billingContent: null,
        buttonBilling: 'Start my subscription',
        buttonHint: `(Payment will be taken and your account will be unlocked immediately. You can cancel at any time)`,
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      expired_with_invalid_card: {
        title: 'Your card has expired. Subscribe to reactivate your account.',
        billingContent: plan => <div className='sales-modal-billing-content'>
          <strong>Subscribe to Wordtracker</strong> for just ${plan.unit_amount_in_cents/100}/month.
          <div className='sales-modal-billing-spacer-lg'></div>
        </div>,
        buttonBilling: 'Start my subscription',
        buttonHint: `(Payment will be taken and your account will be unlocked immediately. You can cancel at any time)`,
        doneHtml: <p>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      out_of_ranking_lists: {
        title: null,
        billingContent: plan => <div className='sales-modal-billing-content'>
          <strong>Create up to {tiers[plan.tier].limits.ranking_lists} ranking lists</strong> by upgrading your subscription.
          <div className='sales-modal-billing-spacer'></div>
        </div>,
        buttonBilling: 'Upgrade now',
        buttonHint: subscription => `(Click the button above and choose a plan with more lists to continue.${subscription.trial ? " Any remaining trial time will be refunded." : ""})`,
        doneHtml: <p>
          Upgrade complete!<br/>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      out_of_daily_searches: {
        title: (plan, user) => <>You've used your {getLimitsForTier(getUserTier(user)).searches_per_day.toLocaleString()} daily searches.</>,
        subtitle: plan => <>Run up to {tiers[plan.tier].limits.searches_per_day.toLocaleString()} searches a day by upgrading to a <span className={`tier-${plan.tier}`}>{plan.tier.charAt(0).toUpperCase() + plan.tier.slice(1)}</span> subscription.</>,
        billingContent: null,
        buttonBilling: <>View all plans &nbsp;<i className='fa-solid fa-arrow-right'></i></>,
        buttonHint: `More searches, more keywords, more results`,
        doneHtml: <p>
          Upgrade complete!<br/>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      },
      curious_about_ranking_lists: {
        title: null,
        billingContent: plan => <div className='sales-modal-billing-content'>
          <strong>Create up to {tiers[plan.tier].limits.ranking_lists} ranking lists</strong> by upgrading your subscription.
          <div className='sales-modal-billing-spacer'></div>
        </div>,
        buttonBilling: 'Upgrade now',
        buttonHint: subscription => `(Click the button above and choose a plan with more lists to continue.${subscription.trial ? " Any remaining trial time will be refunded." : ""})`,
        doneHtml: <p>
          Upgrade complete!<br/>
          A receipt has been emailed to you for your records.<br/>
          One moment while we refresh your account status...
        </p>
      }
    }
  },
  bronze_trial_plan: {
    states: {
      default: {
        title: `Get everything Wordtracker has to offer for a month for $${plans.bronze_trial_plan.unit_amount_in_cents / 100}`,
        buttonDetails: 'Continue...',
        priceMark: <span className='price-mark price-mark-smaller'><span className='dollar-sign'>$</span>{plans.bronze_trial_plan.unit_amount_in_cents / 100}<span className='only'>only</span></span>,
        buttonBilling: `Start my $${(plans.bronze_trial_plan.unit_amount_in_cents / 100)} trial`,
        buttonDetailsHint: <>Get Wordtracker for just <strong>${plans.bronze_trial_plan.unit_amount_in_cents / 100} for a month</strong>,<br/>and <span className='full-price-hint'>only <strong>${plans.bronze_monthly.unit_amount_in_cents / 100}/month</strong> after that</span>, forever.</>,
        buttonHint: <><span className='full-price-hint'>Regular price <strong>${plans.bronze_monthly.unit_amount_in_cents / 100}/month</strong></span> after your first month. <br/>Cancel any time. By signing up you agree to our <a href='/terms' target='_blank'>terms</a>.</>,
      }
    }
  }
}

const customBenefits = {
  bronze_trial_plan: [
    { key: 'searches', label: 'Unlimited searches' },
    { key: 'results', label: 'Up to 1000 results' },
    { key: 'domains', label: 'Analyze unlimited domains' },
    { key: 'ranking_keywords', label: 'Track rank of up to 1000 keywords' },
    { key: 'exports', label: 'Full data exports' }
  ]
};

export const getLimitsForTier = (tier) => tiers[tier].limits;

const buildBenefitsFromLimits = (tier) => {
  const limits = tiers[tier].limits;
  return [
    { key: 'searches', label: 'Unlimited searches' },
    ...Object.entries(limits).map(([key, value]) => {
      const label = value === -1 ? `Unlimited ${key.replaceAll('_', ' ')}` : `${value} ${key.replaceAll('_', ' ')}`;
      return { key, label };
    })
  ];
};

export const getCoupon = id => {
  return coupons[id];
}

export const getBenefitsForPlan = plan => {
  return customBenefits[plan.id] || customBenefits[plan.lookup_key] || buildBenefitsFromLimits(plan.tier);
}

export const getFunnelContent = (priceId, funnel, couponId) => {
  let planSalesObj = sales.hasOwnProperty(priceId) ? sales[priceId] : sales.generic_plan;
  let salesTextObj = {...planSalesObj.states.default};

  const stateObj = planSalesObj.states[funnel];
  if (stateObj) {
    Object.entries(stateObj).forEach(([key, value]) => {
      salesTextObj[key] = value;
    })
  }
  const couponObj = coupons[couponId];
  if (couponObj) {
    Object.entries(couponObj.salesText).forEach(([key, value]) => {
      salesTextObj[key] = value;
    });
  }
  return salesTextObj;
}

const actionDescriptions = {
  clickedExport: 'export your results',
  requestedBulkSearch: 'use bulk search',
  clickedSaveToList: 'save to a list',
  clickedLockedCountry: 'search in more countries',
  clickedGSC: 'connect Google Search Console',
  clickedSeeMoreKeywords: 'see more keywords',
  clickedGetMoreCompetitors: 'see more competitors',
  clickedCreateRankingList: 'create ranking lists',
  requestsExhausted: 'keep searching',
  clickedUnlock: 'unlock all features',
};

export const getActionDescription = (action) => actionDescriptions[action];

export const getPlanByPriceId = id => {
  let price;
  price = plans[id];
  if (!price) {
    price = Object.values(plans).find(_price => _price.plan_code === id);
  }
  if (!price) throw `Plan with id ${id} not found.`;
  return price;
}